export const OPERATORS = {
  e: {
    symbol: '=',
    text: 'equal to',
    dateText: 'on',
  },
  ne: {
    symbol: '!=',
    text: 'not equal to',
    dateText: 'not on',
  },
  e_null: {
    text: 'is null',
    dateText: 'null',
    customKey: 'e',
  },
  ne_null: {
    text: 'is not null',
    dateText: 'not null',
    customKey: 'ne',
  },
  lt: {
    symbol: '<',
    text: 'less than',
    dateText: 'before',
  },
  le: {
    symbol: '<=',
    text: 'less than or equal to',
    dateText: 'on or before',
  },
  gt: {
    symbol: '>',
    text: 'greater than',
    dateText: 'after',
  },
  ge: {
    symbol: '>=',
    text: 'greater than or equal to',
    dateText: 'on or after',
  },
  range: {
    text: 'in the range of',
    dateText: 'on or after',
  },
  codes_in: {
    text: '(at least one) are contained in',
  },
  codes_nin: {
    text: 'are not contained in',
  },
  in: {
    text: 'is matching (regex)',
  },
  nin: {
    text: 'is not matching (regex)',
  },
  includedin: {
    // is included in list
    text: 'is in',
  },
  notincludedin: {
    // is not included in list
    text: 'is not in',
  },
  con: {
    text: 'contains',
  },
  ncon: {
    text: 'does not contain',
  },
};

export const STRING_OPERATORS = ['e', 'ne', 'in', 'nin', 'con', 'ncon', 'includedin', 'notincludedin'];
export const MATCHING_OPERATORS = ['e', 'ne', 'lt', 'le', 'gt', 'ge', 'includedin', 'notincludedin'];
export const DEFAULT_OPERATORS = [...MATCHING_OPERATORS, 'range'];
export const REASON_CODE_OPERATORS = ['codes_in', 'codes_nin'];
export const DATE_TIMESTAMP_OPERATORS = ['e', 'ne', 'lt', 'le', 'gt', 'ge'];
export const NULL_OPERATORS = ['e_null', 'ne_null'];

export const DEFAULT_OPERATORS_NULL_ALLOWED = [...DEFAULT_OPERATORS, ...NULL_OPERATORS];
export const STRING_OPERATORS_NULL_ALLOWED = [...STRING_OPERATORS, ...NULL_OPERATORS];
